import I18n from 'i18n-js';
import { string } from 'prop-types';

import { useTimer } from '@lootboy/lib/hooks';
import { MINUTE_MS } from '@lootboy/lib/time';
import { getEndOfUTCDay } from '@lootboy/lib/utils/dateAndTime';

import useDailyQuestsCountSelector from '~/redux/hooks/useDailyQuestsCountSelector';

import lightning from '~/assets/images/icons/lightning.svg';

import style from './Dailyheader.module.scss';

export default function DailyHeader({ description }) {
  const completed = !useDailyQuestsCountSelector();
  const { hours, minutes } = useTimer(getEndOfUTCDay(), {
    interval: MINUTE_MS,
  });

  return (
    <section className={style.dailyHeader}>
      <section className={style.iconBox}>
        <img
          src={lightning}
          alt="lightning"
        />
      </section>
      <section className={style.descriptionBox}>
        <h1 className={style.title}>{I18n.t('DailyView_bc')}</h1>
        <p className={style.subTitle}>
          {completed
            ? I18n.t('DailyView_completed', {
                hoursLeft: hours,
                minutesLeft: minutes,
              })
            : description.replace('{HH}', hours).replace('{MM}', minutes)}
        </p>
      </section>
    </section>
  );
}

DailyHeader.propTypes = {
  description: string,
};
